// splits a settled prediction's total awardedPoints into its components:
//   result = the outcome (win/draw) points, exact = exact-score bonus, bonus = manual lever.
// the exact-score bonus amount (exactScorePoints) comes from the backend so the reward value
// lives in one place; awardedPoints already includes both exact and bonus, so result is the
// remainder. returns null when the prediction isn't settled yet (awardedPoints == null).
export const pointsBreakdown = (item) => {
  const total = item.awardedPoints;
  if (total == null) return null;
  const exact = item.exactScorePoints > 0 ? item.exactScorePoints : 0;
  const bonus = item.bonusPoints > 0 ? item.bonusPoints : 0;
  const result = total - exact - bonus;
  return { result, exact, bonus, total, hasParts: exact > 0 || bonus > 0 };
};

// "+120" / "-90"
export const signed = (n) => (n >= 0 ? `+${n}` : `${n}`);
